import { useEffect } from "react"
import Architecture from "../logic/Architecture"
import { Guide, PageHandle, packPageHandle } from "../logic/Guide"
import { Brick } from "../logic/bricks"
import { Scenario } from "../logic/scenarios/data"
import { packScenario } from "../logic/scenarios/serialization"
import { NotSupportedLinks, isSupported } from "../logic/scenarios/validation"
import { PageDescriptor } from "../pages/types"
import ArchitectureDiagram from "./ArchitectureDiagram"
import PageViewer from "./PageViewer"
import TableOfContents from "./TableOfContents"
import { Alert } from "reactstrap"

type GuideViewerProps = {
    scenario: Scenario
    pageHandle: PageHandle
    isPrint: boolean
    navigate: (handle?: PageHandle) => void
    licenseID?: string
}

const GuideViewer = ({ isPrint, scenario, navigate, pageHandle, licenseID }: GuideViewerProps) => {
    const architecture = Architecture.Create(scenario)
    const guide = Guide.Create(scenario, architecture)
    const current = guide.validatePageHandle(pageHandle)
    const result = guide.getPage(current)
    if(result == undefined) {
        throw new Error('Invalid page')
    }
    const [section, page] = result
    
    const brick = section.brick
    const supported = isSupported(scenario)

    const navigateBrick = (target: Brick) => {
        const handle = guide.getFirstBrickPage(target.key())
        navigate(handle)
    }

    const packedPage = packPageHandle(current)
    const packedScenario = packScenario(scenario)
    useEffect(() => {
        const url = new URL(window.location.href)
        const traceUrl = url.protocol + "//" + url.hostname + "/track"
        const body = { scenario, page: current, licenseID }
        fetch(traceUrl, {
            method: 'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
    }, [packedPage, packedScenario])

    const architectureDiagram = <ArchitectureDiagram architecture={architecture} activeBrick={brick} onNavigate={navigateBrick} />
    const pageViewer = (page: PageDescriptor) => <PageViewer key={page.key} page={page} guide={guide} section={section} onNavigate={navigate} print={isPrint} />
    const toc = <TableOfContents guide={guide} current={current} isPrint={isPrint} onNavigate={navigate} />

    if (isPrint) {
        return (
            <div className="print">
                {toc}
                {guide.sections.map(section =>
                    <>
                        <h1>{section.title}</h1>
                        {section.pages.map(pageViewer)}
                    </>
                )}
            </div>
        )
    } else {
        return (
            <>
                {/*<div className="container-fluid g-0">*/}
                    {toc}                        
                    <main>
                        {architectureDiagram}
                        {supported && <section style={{margin:'1em 0'}}><Alert color="warning">{supported} <NotSupportedLinks/></Alert></section>}
                        {pageViewer(page)}
                    </main>                        
                {/*</div>*/}
            </>
        )
    }    
}

export default GuideViewer